<!-- Card Header-->
<div class="ui-fluid">
  <div class="ui-grid-row">
    <app-acceuil-card></app-acceuil-card>
  </div>
  <div class="ui-grid-row">
    <!-- STATISTIQUE MODERATION-->
    <div class="ui-g-12">
      <app-statistique-moderation-card></app-statistique-moderation-card>
    </div>
  </div>
  <div class="ui-grid-row">
    <!-- RESUME CARD -->
    <div class="ui-g-6">
      <app-statistique-timeline-card></app-statistique-timeline-card>
    </div>
    <!-- RESUME UTILISATEUR -->
    <div class="ui-g-6">
      <app-statistique-user-card></app-statistique-user-card>
    </div>
  </div>
</div>

